export default __webpack_public_path__ + "static/course1-b5bfd006f69ba2ae6f3c4758ef5d99e7.jpg";